import { encode } from "js-base64";

export const createAuthString = (login: string, pwd: string) => {
    const b64 = encode(login + ":" + pwd);
    // localStorage.setItem("auth", b64);
    return b64;
};
